import React from 'react';
import {ModalLoaderProps} from './ModalLoader.type';
import SVGIcons from '@components/SVGIcon';

import cn from './ModalLoader.module.scss';

export function ModalLoader(props: ModalLoaderProps) {
  return (
    props.loading && (
      <div className={cn.loaderContainer} data-testid='loader-container'>
        <div className={cn.loader} data-testid='loader'>
          <SVGIcons type={'spinner-svg'} />
        </div>
      </div>
    )
  );
}
